var _mask, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 4,
    viewBox: "0 0 10 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_9978_2249",
    maskUnits: "userSpaceOnUse",
    x: 0.25,
    y: 0.135254,
    width: 10,
    height: 4,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.25,
    y: 0.135254,
    width: 10,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 1.88525C1.25 1.48682 1.57812 1.13525 2 1.13525H8C8.39844 1.13525 8.75 1.48682 8.75 1.88525C8.75 2.30713 8.39844 2.63525 8 2.63525H2C1.57812 2.63525 1.25 2.30713 1.25 1.88525Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 1.88525C1.25 1.48682 1.57812 1.13525 2 1.13525H8C8.39844 1.13525 8.75 1.48682 8.75 1.88525C8.75 2.30713 8.39844 2.63525 8 2.63525H2C1.57812 2.63525 1.25 2.30713 1.25 1.88525Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 1.88525C2.25 1.96188 2.21931 2.02164 2.18147 2.0603C2.14064 2.10202 2.0754 2.13525 2 2.13525V0.135254C1.00567 0.135254 0.25 0.954915 0.25 1.88525H2.25ZM2 2.13525H8V0.135254H2V2.13525ZM8 2.13525C7.90298 2.13525 7.84401 2.09465 7.81731 2.06795C7.7906 2.04124 7.75 1.98227 7.75 1.88525H9.75C9.75 0.934532 8.95072 0.135254 8 0.135254V2.13525ZM7.75 1.88525C7.75 1.80986 7.78324 1.74462 7.82495 1.70379C7.86362 1.66594 7.92337 1.63525 8 1.63525V3.63525C8.93034 3.63525 9.75 2.87958 9.75 1.88525H7.75ZM8 1.63525H2V3.63525H8V1.63525ZM2 1.63525C2.0548 1.63525 2.1215 1.65895 2.1739 1.71135C2.22631 1.76375 2.25 1.83046 2.25 1.88525H0.25C0.25 2.85941 1.02584 3.63525 2 3.63525V1.63525Z",
    fill: "#666666",
    mask: "url(#path-1-outside-1_9978_2249)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayDash);
export default __webpack_public_path__ + "static/media/gray-dash.257a16d6cbd3af824ff862438bee34c8.svg";
export { ForwardRef as ReactComponent };